// extracted by mini-css-extract-plugin
module.exports = {"logo":"_2wpUL2ddfq9JDdIMQj46w9","sarov":"_3F6bAoY4WLY8c_7iPOHL5K","zv":"_3Uu-tnjJKdkJG3AF170Mzk"};